import React from 'react';

import { flow } from '@code-expert/prelude';
import { zero } from '/imports/modules/Routing';
import { Authorise } from '/imports/ui/components/Authorise';
import { pathToUrl } from '/imports/ui/helper/url';
import type { ExercisePrintViewParams, TaskPrintViewUrlParams } from './routes';
import { exercisePrintViewPath, exercisePrintViewRoute, taskPrintViewRoute } from './routes';

const Print = React.lazy(() => import('./Print'));

const printView = (args: ExercisePrintViewParams | TaskPrintViewUrlParams) => (
  <Authorise deny={['exam', 'lti']}>
    <Print {...args} />
  </Authorise>
);

export const exercisePrintViewUrl = flow(exercisePrintViewPath, pathToUrl);

export const printRouter = zero()
  .alt(exercisePrintViewRoute.parser.map(printView))
  .alt(taskPrintViewRoute.parser.map(printView));
